export const PAGE_TYPE_PAYMENT = 'payment';
